import { Component } from '@angular/core';
import { URLSearchParams, Http, Response, Headers } from '@angular/http';

import 'rxjs/add/operator/map'
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  private url = 'http://www.cloudfactory.eu/rest/wp-json/wp/v2/pages?context=embed&orderby=id&order=asc';
  public pages:any;
  private id: number;
  private error = {
                    status : null,
                    statusText: null
                  };

  constructor(private http: Http) { };
  ngOnInit(){
      this.getPages();
  }

  getPages(){
    this.reset();
    let params = new URLSearchParams();
    let timeStamp = ""+new Date();    
    params.set('tsp', timeStamp);  

    this.http.get(this.url, { search: params })
    .subscribe(
      data => {
        this.pages = JSON.parse(data["_body"]);
        // console.log(JSON.parse(data["_body"]));
      },
      error => {
        this.error.status = error.status;
        this.error.statusText = error.statusText;
        console.error(error);
      });
  }

  reset(){
    this.pages = null;
    this.error.status = null;
    this.error.statusText = null;
  }
}









// WEBPACK FOOTER //
// C:/Users/bompadre/Documents/angular2/myapp2/src/app/app.component.ts